export default "__VITE_ASSET__CIJ9R3BP__"